import RSDetails from './rates/RSDetails';

import standardService from './rates/StandardService';
import VoluntaryDetails from './rates/VoluntaryDetails';
import evSmartChargeVTOU from './rates/evSmartChargeVTOU';
import rateOffPeak from './rates/vtou';

//OBS: For the rates data, the max and min ALWAYS need to have 12 elements.

// SC-1 = standardService
// VTOU = residentialVoluntaryTimeOfUse
// EV Smart Charge Plan SC-1 = National Grid-EVSmartChargeSC-1
// EV Smart Charge Plan SC-1-VTOU = National Grid-EVSmartChargeVTOU

const rates = {
  'SC-1': {
    id: 'SC-1',
    title: ['SC-1 Rate'],
    subTitle: [''],
    data: standardService,
    detailsComponent: RSDetails,
  },
  VTOU: {
    id: 'VTOU',
    title: ['VTOU'],
    subTitle: [''],
    data: rateOffPeak,
    detailsComponent: VoluntaryDetails,
  },
  'EV-SC-1-VTOU': {
    id: 'EV-SC-1-VTOU',
    title: ['EV Smart Charge Plan SC-1-VTOU'],
    subTitle: [''],
    data: evSmartChargeVTOU, // we are not using this rate, it has a discount base to SC-1 in the code
    detailsComponent: VoluntaryDetails,
  },
};

export default rates;
